import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Avatar,
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  IconButton,
  Typography,
  Zoom,
} from "@mui/material";
import bkstApi from "../../common/api";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ChatCanvas from "../../common/component/chat/ChatCanvas";
import NewMessage from "../../common/component/chat/NewMessage";
import { STORAGE_BUCKET } from "../../common/constants";
import ConfigContext from "../../common/context/ConfigContext";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

export default function OrderChat(props) {
  const { orderId } = props;
  const siteConfig = useContext(ConfigContext);

  const ref = useRef(null);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(window.location.hash.includes("chat"));
  const [chat, setChat] = useState(props.chat);

  useEffect(() => {
    if (open) {
      bkstApi(`/order/${orderId}/chat`).then((res) => {
        setChat(res.data.chat || []);
      });
    }
  }, [open]);

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.scrollIntoView();
    }
  }, [chat]);

  const handleNewMsg = (msg) => {
    const allMsgs = [...chat, msg];
    setChat(allMsgs);
  };

  return (
    <Box display="inline">
      <Zoom in={!open} unmountOnExit>
        <Fab
          color="info"
          sx={{ position: "fixed", bottom: "20px", right: "20px" }}
          onClick={(e) => setOpen(true)}
          aria-label="Send us a message"
          variant="extended"
        >
          <ChatBubbleOutlineIcon sx={{ mr: 1 }} />
          SEND MESSAGE
        </Fab>
      </Zoom>
      <Dialog
        fullScreen={fullScreen}
        fullWidth
        maxWidth={fullScreen ? false : "sm"}
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle style={{ margin: "0", padding: "10px" }}>
          <Box display="flex" alignItems="center" gap="10px">
            <Avatar
              alt={`${siteConfig.biz} logo`}
              src={`${STORAGE_BUCKET}/img/b/${siteConfig.id}/logo400.webp`}
            />
            <Typography variant="subtitle1">{siteConfig.biz}</Typography>
          </Box>
          <IconButton
            color="inherit"
            size="small"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
            aria-label="close chat"
          >
            <CloseIcon sx={{ color: "#999" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          className="chat-bg"
          style={{
            minHeight: "50vh",
            padding: "0",
            margin: "0",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box mb={1} sx={{ display: "flex", flexDirection: "column", flexGrow: "1" }}>
            <ChatCanvas chat={chat} uid={props.uid} />
            <Box textAlign="center" ref={ref}>
              <Chip label="VIEW ORDER" color="primary" onClick={() => setOpen(false)} />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            margin: 0,
            border: 0,
            paddingBottom: "10px",
            paddingRight: "10px",
            paddingLeft: 0,
            paddingTop: 0,
          }}
        >
          <Box sx={{ flexGrow: "1" }}>
            <NewMessage
              handleNewMsg={handleNewMsg}
              uploadFolder={`img/o/${orderId}`}
              postUrl={`/order/${orderId}/chat`}
            />
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
